import Layout from "./Layout.presenter";

export default Layout;
